import { call, put } from "redux-saga/effects";
import { Mixpanel } from "../../../services/Mixpanel";
import { setCookie } from "../../../utils/cookies";

// API
import { loginWithApple } from "../../../api";

// Actions
import { authActions } from "../../../actions/auth";

const extractNames = (displayName) => {
  if (!displayName) return { firstName: '', lastName: '' };
  
  // Replace '+' with space and then split by space
  const nameParts = displayName.replace(/\+/g, ' ').split(' ').filter(part => part.length > 0);
  
  if (nameParts.length === 0) return { firstName: '', lastName: '' };
  if (nameParts.length === 1) return { firstName: nameParts[0], lastName: '' };
  
  // First name is the first part, last name is the last part
  return {
    firstName: nameParts[0],
    lastName: nameParts[nameParts.length - 1]
  };
};

export function* appleSignIn({ payload: { user, idToken, location, history } }) {
  
  yield put(authActions.startLoading());

  try {
    const { firstName, lastName } = extractNames(user.displayName);
    
    const credentials = {
      id_token: idToken,
      first_name: firstName,
      last_name: lastName,
      email: user.email,
      location: location || null // Ensure location is null if not provided
    };
    
    const { response, error } = yield call(loginWithApple, credentials);
    
    yield put(authActions.finishLoading());

    if (response) {
      yield put(authActions.loginSuccess(response));

      // Store user token & info in localStorage
      yield call([localStorage, "setItem"], "access_token", response.profile.token);
      yield call(setCookie, "access_token", response.profile.token, 30);
      yield call([localStorage, "setItem"], "user_info", JSON.stringify(response));
      yield call(setCookie, "user_info", encodeURIComponent(JSON.stringify(response)), 30);

      if (response.is_new_user) {
        // Set user creation date for new users with user-specific key
        const now = new Date().toISOString();
        const timestamp = Math.floor(Date.now() / 1000); // Unix timestamp in seconds
        const userSpecificCreationKey = `user_creation_date_${response.uid}`;
        const userSpecificTimestampKey = `user_creation_timestamp_${response.uid}`;
        const userSpecificReminderKey = `profile_reminder_shown_${response.uid}`;
        
        // Set creation date and initialize reminder shown to false
        yield call([localStorage, "setItem"], userSpecificCreationKey, now);
        yield call([localStorage, "setItem"], userSpecificTimestampKey, timestamp.toString());
        yield call([localStorage, "setItem"], userSpecificReminderKey, "false");
      }

      // Handle redirect
      const lastUrl = localStorage.getItem("lastUrl");
      
      if (lastUrl) {
        yield call([history, "push"], lastUrl);
        yield call([localStorage, "removeItem"], "lastUrl");
      } else {
        if (response.business_role) {
          yield call([history, "push"], `/${response.slug}/profile/artefacts`);
        } else {
          yield call([history, "push"], `/${response.slug}/profile`);
        }
      }

      // Track in Mixpanel
      if (response.profile?.email) {
        Mixpanel.identify(response.profile.email);
        Mixpanel.track('Log In');
        Mixpanel.people.set({
          $name: response.profile.first_name,
          $email: response.profile.email,
        });
      }
    } else if (error) {
      yield put(authActions.loginFailed(error));
    }
  } catch (error) {
    yield put(authActions.loginFailed(error.message));
    console.error("Apple login error:", error);
  }
} 